"use client";
import { Select, SelectItem } from "@nextui-org/react";
import React from "react";

const SelectField = ({
  label,
  className,
  placeholder,
  options = [],
  onChange,
  ...rest
}) => {
  return (
    <div className="mb-4 ">
      <Select
        labelPlacement="outside"
        label={label}
        onChange={(e) => onChange(e.target.value)}
        placeholder={[placeholder]}
        className={`${className ? className : ""} w-full`}
        classNames={{
          label:
            "block text-sm font-semibold leading-6 !text-black-900 mb-1 capitalize p-0 m-0",
          base: "!m-0",
          trigger:
            "bg-0 rounded-none border-b-1 border-[#dcdcdc] shadow-none p-0",
          mainWrapper: "w-full mt-[14px]",
          helperWrapper: "p-0 ",
          errorMessage: "text-red-500 first-letter:capitalize",
          isInvalid: "text-red-500",
          innerWrapper: "text-xs",
          value: "text-xs",
        }}
        {...rest}
      >
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
};
export default SelectField;
